var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"footer"},[_c('ul',[_c('Links',{attrs:{"linkKey":"footer"}})],1),_vm._v(" "),_c('div',{staticClass:"copyright"},[_vm._v("All Content Copyright (©) Joshua Jung, 2020")])])}
var staticRenderFns = []

export { render, staticRenderFns }